import {AdditionalFilter, AllFields} from './chartFilters';
import {AggregationChoice, chartHeightValues, ChartType, chartWidthValues} from 'views/storyboard/utils/chartConstants';
import {EventTextFieldOption} from 'entities/event';

export enum ChartOutput {
    TimelineByDate = 'timeline_by_date',
    TermsTimeline = 'terms_timeline',
    MultiTermsTimeline = 'multi_terms_timeline',
    MetricTimeline = 'metric_timeline',
    TermsMetric = 'terms_metric',
    Terms = 'terms',
    MultiTerms = 'multi_terms',
    NestedTerms = 'nested_terms',
    Trending = 'trending',
    Disappearing = 'disappearing',
    PivotTerms = 'pivot_terms',
}

export enum BarOrientation {
    Vertical = 'vertical',
    Horizontal = 'horizontal',
}

export enum BarSortOrder {
    HighToLow = 'high_to_low',
    LowToHigh = 'low_to_high',
}

export enum DataLabelPosition {
    Off = 'off',
    Above = 'above',
    Inside = 'inside',
}

export {EventTextFieldOption as ChartFieldToQueryOption};

export enum ChartIntervalUnit {
    Hour = 'h',
    Day = 'd',
    Week = 'w',
    Month = 'M',
    Quarter = 'q',
    Year = 'y',
}

export enum AggregationType {
    Count = 'count',
    Average = 'avg',
    Sum = 'sum',
    Min = 'min',
    Max = 'max',
    MedianAbsoluteDeviation = 'median_absolute_deviation',
    ValueCount = 'value_count',
    Histogram = 'histogram',
}

export interface ChartFilteringList {
    value: number;
    label: string;
}


export interface ChartQuery {
    id?: number;
    query_string: string;
    n_gram: number;
    output?: ChartOutput;  // TODO this should be optional only for specific chart types not all
    aggs_item: string | null;
    aggs_item_list: AggregationChoice[];
    intervalUnit: ChartIntervalUnit;
    intervalNumber: number;
    additionalData: {
        comment: string,
    };
    fields_to_query: EventTextFieldOption;
    filtering_lists: ChartFilteringList[];
    metric_interval: number;
    all_fields: AllFields;
    additionalFilters: AdditionalFilter[];
    concordance_lines: number;
    concordance_query: string;
    concordance_width: number;
    metric_timeline_type: AggregationType;
    metric_aggregations_type: AggregationType;
    metric_aggregations_aggs_item: string | null; // Cross table specific
    pivot_col_aggs_item: string | null;
    trending_or_disappearing: string;
    trending_comparable_period: number;
    trending_period: string;
    nested_terms_include_missing: boolean;
    wordcloud_most_common_words?: number;
    wordcloud_text_start_point?: number;
    wordcloud_text_end_point?: number;

    limit?: number;
}

export interface PartialChartQuery extends Exclude<Partial<ChartQuery>, 'query_string'> {
    query_string: string;
}

export interface ChartSettings {
    id?: number;
    storyboardId?: number | null;
    title: string;
    description: string;
    type: ChartType;
    movingAverageDays: null | number;
    linearRegression: boolean;
    comparablePeriod: boolean;
    ignoreGlobalFilters?: boolean;
    scalingFactor: string;
    height: typeof chartHeightValues[number];
    width: typeof chartWidthValues[number];
    movingAverageDaysCenter: boolean;
    barOrientation: BarOrientation;
    barSortOrder: BarSortOrder;
    dataLabelPosition: DataLabelPosition;
}

export interface ChartPostData extends ChartSettings {
    search_query: ChartQuery;
    chartQueryId?: number;
    chartId?: number;
}

export interface Chart extends Omit<ChartSettings, 'storyboardId'> {
    chartQuery: ChartQuery;
    storyboardId: number;
}
